import { render, staticRenderFns } from "./CertificateDetails.vue?vue&type=template&id=36a076e6&scoped=true"
import script from "./CertificateDetails.vue?vue&type=script&lang=js"
export * from "./CertificateDetails.vue?vue&type=script&lang=js"
import style0 from "./CertificateDetails.vue?vue&type=style&index=0&id=36a076e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a076e6",
  null
  
)

export default component.exports